// Showing the first few of something, and putting the rest one click away.
//
// The pricing-sheet review is a report about a document, and a real document
// produces 54 categories, 58 rate rows and 29 rate blocks. Rendered in full that
// is a page nobody reaches the end of — the thing a reviewer is supposed to
// DECIDE was buried under evidence they were never going to read row by row.
//
// So each collection shows five and says how many there are. Five is enough to
// see the shape — are these rates plausible, do these titles look like jobs —
// and the count is what says whether to go looking. "View all 54" opens the same
// table in a wide drawer, where the reader has chosen to be exhaustive.
//
// The five are the WORST five, not the first five, because every one of these
// collections is already sorted worst-first by severity. A peek that showed the
// most boring rows would be decoration.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraOverlayDrawer, SpecraSectionHeader } from '@mono/ui-components';
import { useState } from 'react';
/** How many rows a peek shows before it defers to the drawer. */ export const PEEK_ROWS = 5;
export function PricingSheetPeek({ action, children, description, drawerEyebrow, renderAll, shown = PEEK_ROWS, testId, title, total, viewAllTestId }) {
    const [open, setOpen] = useState(false);
    const hidden = total - shown;
    return /*#__PURE__*/ _jsxs("section", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                action: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [
                        action,
                        hidden > 0 ? // The count is in the label, not just the tooltip: "View all 54"
                        // tells a reviewer whether the five they can see are most of the
                        // story or a tenth of it.
                        /*#__PURE__*/ _jsxs(SpecraButton, {
                            "data-testid": viewAllTestId,
                            onClick: ()=>setOpen(true),
                            variant: "outline",
                            children: [
                                "View all ",
                                total.toLocaleString()
                            ]
                        }) : null
                    ]
                }),
                headingAs: "h3",
                title: `${title} (${total.toLocaleString()})`
            }),
            description ? /*#__PURE__*/ _jsx("p", {
                className: "mt-1 text-[length:var(--fs-ui-caption)] text-muted-foreground",
                children: description
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: "mt-3",
                children: children
            }),
            hidden > 0 ? /*#__PURE__*/ _jsxs("p", {
                className: "mt-2 text-[length:var(--fs-ui-caption)] text-muted-foreground",
                children: [
                    "Showing the ",
                    shown.toLocaleString(),
                    " that most need a look. ",
                    hidden.toLocaleString(),
                    ' ',
                    "more."
                ]
            }) : null,
            /*#__PURE__*/ _jsx(SpecraOverlayDrawer, {
                eyebrow: drawerEyebrow,
                onOpenChange: setOpen,
                open: open,
                title: `${title} (${total.toLocaleString()})`,
                // xl, because these are wide tables and a reader who opened this asked
                // for all of it — squeezing 58 rows of five periods into a phone-width
                // panel would be a worse version of the page they came from.
                width: "xl",
                children: open ? renderAll() : null
            })
        ]
    });
}
